export default "__VITE_ASSET__DonAPEXX__"